export const ROUTES = {
  HOME: '/',
  SIGN_IN: '/signin',

  // Admin
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_DATA: '/admin/user-data',
  ADMIN_SESSIONS: '/admin/sessions',
  ADMIN_SESSION: '/admin/sessions/:id',
  ADMIN_COACHES: '/admin/coaches',

  // Content
  PREVIEWER: '/previewer',

  // Tariffs
  TARIFFS: '/tariffs',

  // Coach
  COACH: '/coach',
  COACH_CALENDAR: '/coach/calendar',
  COACH_SCHEDULE: '/coach/schedule',
};
